import React from 'react';
import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { formatMoney } from '../../utils/formatMoney';
import './styles/productCard.scss';

function ProductCardComponent(props) {

  const { product } = props;

  const handleClick = () => {
    props.history.push(`/productos/${product._id}`);
  };

  const price = product.hasDelivery ? product.price : product.price + product.deliveryPrice;

  return (
    <div className="product-card-component">
      <div className="product-thumbnail-container">
        <div className="product-thumbnail" style={{ backgroundImage: `url(${product.thumbnail})` }} />
      </div>
      <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
        <div className="product-name">{product.name}</div>
        <div className="product-price">
          <span>{formatMoney(price)}</span>
        </div>
        <Button onClick={handleClick} className="app-button product-buy-button">
          Comprar
        </Button>
      </div>
    </div>
  );
}

export default withRouter(ProductCardComponent);
